import _debounce2 from "lodash/debounce";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classNames from 'classnames';
import { getDefaultValue as getDefaultStateForCountry } from 'swag-common/utils/shipping';
import { StatePicker } from 'swag-client-common/components/pickers/state-picker';
import { COUNTRIES_WITH_STATES, COUNTRY_CODES } from 'swag-common/constants/shipping.constants';
import AutocompleteAddressList from 'swag-client-common/components/partials/autocomplete-address-list';
import { DeliveryKeys } from 'swag-client-common/constants/delivery';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { Placement, PHONE_NUMBER_TOOLTIP } from 'swag-client-common/constants';
import { infoIconWithDynamicColor } from 'swag-client-common/components/icons/info-icon-with-dynamic-colors';
import { pickerStyles } from './constants';
import { ShippingCountryPicker } from './components/shipping-country-picker';
import classes from './shipment-inputs.scss';
const defaultPlaceholderFieldCreator = sign => (placeholderName, isRequired = false) => {
  if (!isRequired) {
    return placeholderName;
  }
  return `${placeholderName}${sign}`;
};
class ShippingInputsPure extends React.PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      isOpen: false,
      isAddressEntered: false
    });
    _defineProperty(this, "dropdown", /*#__PURE__*/React.createRef());
    _defineProperty(this, "input", /*#__PURE__*/React.createRef());
    // tslint:disable:member-ordering
    _defineProperty(this, "onFieldChange", fieldName => e => {
      const {
        onShippingNameEdit
      } = this.props;
      onShippingNameEdit(fieldName, e.target.value);
    });
    _defineProperty(this, "fetchAddress", _debounce2(this.props.onAddressFetch, 1000));
    _defineProperty(this, "onFirstNameChange", e => {
      const {
        onShippingNameEdit
      } = this.props;
      onShippingNameEdit(DeliveryKeys.FirstNameShipping, e.target.value);
    });
    _defineProperty(this, "onLastNameChange", this.onFieldChange(DeliveryKeys.LastNameShipping));
    _defineProperty(this, "onUnitChange", this.onFieldChange(DeliveryKeys.Unit));
    _defineProperty(this, "onCityChange", this.onFieldChange(DeliveryKeys.City));
    _defineProperty(this, "onZipChange", this.onFieldChange(DeliveryKeys.Zip));
    _defineProperty(this, "onEmailChange", this.onFieldChange(DeliveryKeys.Email));
    _defineProperty(this, "onPhoneChange", this.onFieldChange(DeliveryKeys.FormPhone));
    _defineProperty(this, "onCountryChange", event => {
      const {
        onShippingCountryEdit
      } = this.props;
      onShippingCountryEdit(event.target.value);
    });
    _defineProperty(this, "onStateChange", event => {
      const {
        onShippingStateEdit
      } = this.props;
      onShippingStateEdit(event.target.value);
    });
    _defineProperty(this, "onShippingStateChange", e => {
      const {
        onShippingStateEdit
      } = this.props;
      onShippingStateEdit(e.target.value);
    });
    _defineProperty(this, "handleAddressChange", e => {
      const {
        value
      } = e.target;
      const {
        onShippingNameEdit,
        isAddressEnteredManually
      } = this.props;
      onShippingNameEdit(DeliveryKeys.Address, value);
      if (value && value.trim() && !isAddressEnteredManually) {
        this.fetchAddress();
      }
      if (!isAddressEnteredManually && !this.state.isOpen) {
        this.setState({
          isOpen: true
        });
      }
    });
    _defineProperty(this, "checkIsFieldShown", field => {
      const {
        isAddressEntered
      } = this.state;
      const {
        isAddressEnteredManually,
        values,
        withPhone
      } = this.props;
      const isShown = isAddressEnteredManually || !isAddressEnteredManually && values[field] && isAddressEntered || isAddressEntered;
      if (DeliveryKeys.FormPhone === field) {
        return isShown && withPhone;
      }
      return isShown;
    });
    _defineProperty(this, "handleAddressSelect", params => {
      this.props.onAddressSelect(params);
      this.setState({
        isOpen: false,
        isAddressEntered: true
      });
    });
    _defineProperty(this, "handleManualEnterSelect", () => {
      this.props.onManualEnterClick();
      this.setState({
        isOpen: false,
        isAddressEntered: true
      });
    });
    _defineProperty(this, "handleClickOutside", event => {
      const isElementsExists = this.dropdown && this.input;
      if (!isElementsExists || !this.dropdown.current || !this.input.current) {
        return;
      }
      const notAtDropdown = !this.dropdown.current.contains(event.target);
      const notAtInput = !this.input.current.contains(event.target);
      const notAtAddress = notAtDropdown && notAtInput;
      if (isElementsExists && notAtAddress) {
        this.setState({
          isOpen: false
        });
      }
    });
    _defineProperty(this, "checkIsAddressExists", (prevValues, newValues) => {
      const isAddressPredefined = Boolean(prevValues.zip && prevValues.address);
      const isAddressAdded = Boolean(!prevValues.zip && !prevValues.address && newValues.zip && newValues.address);
      return isAddressPredefined || isAddressAdded;
    });
  }
  componentDidUpdate(prevProps) {
    const {
      values,
      onShippingStateEdit
    } = this.props;
    const {
      country
    } = values;
    if (prevProps.values.country !== country) {
      if (COUNTRIES_WITH_STATES.includes(country)) {
        onShippingStateEdit(getDefaultStateForCountry(country));
      }
    }
    if (this.checkIsAddressExists(prevProps.values, values)) {
      this.setState({
        isAddressEntered: true
      });
    }
  }
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    if (this.checkIsAddressExists({}, this.props.values)) {
      this.setState({
        isAddressEntered: true
      });
    }
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  render() {
    const {
      isOpen
    } = this.state;
    const {
      values: {
        fnameShipping,
        lnameShipping,
        address,
        city,
        unit,
        state,
        country,
        zip,
        email,
        phone,
        zipError = null
      },
      inputClassName,
      manualContainerClassName,
      inputLineClassName,
      selectClassName,
      placeholderFieldCreator = defaultPlaceholderFieldCreator,
      withEmail,
      isAddressLoading,
      loadingComponent: LoadingComponent,
      isAddressEnteredManually,
      autocompleteList,
      onAddressClick,
      isSuperSpeedOrder,
      onlyUsOption
    } = this.props;
    const placeholderNaming = placeholderFieldCreator('*');
    const inputClasses = classNames(classes.input, inputClassName);
    const inputLineClasses = classNames(classes.line, inputLineClassName);
    const isPhoneRequired = country !== COUNTRY_CODES.US || isSuperSpeedOrder;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: inputLineClasses
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.inputWrapper
    }, /*#__PURE__*/React.createElement("input", {
      className: inputClasses,
      placeholder: placeholderNaming('First Name', true),
      type: "text",
      "data-name": "fname",
      value: fnameShipping,
      onChange: this.onFirstNameChange,
      autoComplete: "disabled",
      maxLength: 35
    })), /*#__PURE__*/React.createElement("div", {
      className: classes.inputWrapper
    }, /*#__PURE__*/React.createElement("input", {
      className: inputClasses,
      placeholder: placeholderNaming('Last Name', true),
      type: "text",
      "data-name": "lname",
      value: lnameShipping,
      onChange: this.onLastNameChange,
      autoComplete: "disabled",
      maxLength: 35
    }))), withEmail && /*#__PURE__*/React.createElement("div", {
      className: inputLineClasses
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.inputWrapper
    }, /*#__PURE__*/React.createElement("input", {
      className: inputClasses,
      placeholder: placeholderNaming('Email', true),
      type: "text",
      "data-name": "email",
      value: email,
      onChange: this.onEmailChange,
      autoComplete: "disabled",
      maxLength: 64
    }))), /*#__PURE__*/React.createElement("div", {
      className: inputLineClasses
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.inputWrapper
    }, /*#__PURE__*/React.createElement(ShippingCountryPicker, {
      onlyUsOption: onlyUsOption,
      selectClasses: selectClassName,
      country: country,
      onCountryChange: this.onCountryChange
    }))), /*#__PURE__*/React.createElement("div", {
      className: classNames(inputLineClasses, classes.address, {
        [classes.autocompleteIndent]: !isAddressEnteredManually
      })
    }, isAddressLoading && /*#__PURE__*/React.createElement("div", {
      className: classes.loading
    }, /*#__PURE__*/React.createElement(LoadingComponent, null)), /*#__PURE__*/React.createElement("div", {
      className: classNames(classes.inputWrapper, classes.marginRightZero)
    }, /*#__PURE__*/React.createElement("input", {
      ref: this.input,
      className: inputClasses,
      placeholder: placeholderNaming(isAddressEnteredManually ? 'Street Address' : 'Start typing the first line of your address', true),
      type: "text",
      "data-name": "address",
      value: address,
      onChange: this.handleAddressChange,
      autoComplete: "disabled",
      maxLength: 35
    })), isOpen && !isAddressLoading && /*#__PURE__*/React.createElement(AutocompleteAddressList, {
      onManualEnterClick: this.handleManualEnterSelect,
      onAddressClick: onAddressClick,
      onAddressSelect: this.handleAddressSelect,
      list: autocompleteList,
      getListRef: dropdown => {
        this.dropdown = dropdown;
      }
    }), !isAddressEnteredManually && /*#__PURE__*/React.createElement("div", {
      className: classNames(classes.manualContainer, manualContainerClassName)
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.manualEnter,
      onClick: this.handleManualEnterSelect
    }, "Enter address manually"))), /*#__PURE__*/React.createElement("div", {
      className: inputLineClasses
    }, this.checkIsFieldShown(DeliveryKeys.Unit) && /*#__PURE__*/React.createElement("div", {
      className: classes.inputWrapper
    }, /*#__PURE__*/React.createElement("input", {
      className: inputClasses,
      placeholder: placeholderNaming('Office #, Floor, etc.'),
      type: "text",
      "data-name": "unit",
      value: unit,
      onChange: this.onUnitChange,
      autoComplete: "disabled",
      maxLength: 35
    }))), /*#__PURE__*/React.createElement("div", {
      className: inputLineClasses
    }, this.checkIsFieldShown(DeliveryKeys.City) && /*#__PURE__*/React.createElement("div", {
      className: classes.inputWrapper
    }, /*#__PURE__*/React.createElement("input", {
      className: inputClasses,
      placeholder: placeholderNaming('City', true),
      type: "text",
      "data-name": "city",
      value: city,
      onChange: this.onCityChange,
      autoComplete: "disabled"
    })), this.checkIsFieldShown(DeliveryKeys.State) && /*#__PURE__*/React.createElement("div", {
      className: classes.inputWrapper
    }, COUNTRIES_WITH_STATES.includes(country) ? /*#__PURE__*/React.createElement(StatePicker, {
      wrapperClassName: selectClassName,
      value: state,
      onChange: this.onStateChange,
      style: pickerStyles.style,
      country: country,
      fullWidth: true
    }) : /*#__PURE__*/React.createElement("input", {
      className: inputClasses,
      placeholder: placeholderNaming('State/Region'),
      type: "text",
      "data-name": "state",
      value: state,
      onChange: this.onShippingStateChange,
      autoComplete: "disabled"
    }))), /*#__PURE__*/React.createElement("div", {
      className: inputLineClasses
    }, this.checkIsFieldShown(DeliveryKeys.Zip) && /*#__PURE__*/React.createElement("div", {
      className: classNames(classes.zip, classes.inputWrapper)
    }, /*#__PURE__*/React.createElement("input", {
      className: inputClasses,
      placeholder: placeholderNaming('Zip/Postal Code', true),
      maxLength: 15,
      required: true,
      "data-name": "zip",
      type: "text",
      value: zip,
      onChange: this.onZipChange,
      autoComplete: "disabled"
    })), this.checkIsFieldShown(DeliveryKeys.FormPhone) && /*#__PURE__*/React.createElement("div", {
      className: classNames(classes.phone, classes.inputWrapper)
    }, /*#__PURE__*/React.createElement("input", {
      className: inputClasses,
      placeholder: placeholderNaming('Cell Phone', isPhoneRequired),
      type: "text",
      "data-name": "phone",
      value: phone,
      onChange: this.onPhoneChange,
      autoComplete: "disabled",
      maxLength: 50
    }), /*#__PURE__*/React.createElement(Tooltip, {
      interactive: true,
      title: PHONE_NUMBER_TOOLTIP,
      placement: Placement.RIGHT,
      mode: "light"
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.infoButton
    }, infoIconWithDynamicColor))), zipError && /*#__PURE__*/React.createElement("span", {
      className: classes.error
    }, zipError)));
  }
}
_defineProperty(ShippingInputsPure, "defaultProps", {
  withEmail: false,
  withPhone: false
});
export const ShippingInputs = props => /*#__PURE__*/React.createElement(ShippingInputsPure, props);